<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'TimesheetSkeletonLoader',
  mixins: [baseMixin],
}
</script>

<template>
  <v-skeleton-loader
    loading
    type="week-timesheet-group"
    :types="{
      'week-timesheet-group': 'week-heading, timesheet-card',
      'week-heading': 'heading',
      'timesheet-card': 'avatar-text, timesheet-table',
      'avatar-text': 'avatar, text',
      'timesheet-table': 'table-thead, divider, table-row, divider, table-row',
    }"
    class="timesheet-skeleton-list"
  ></v-skeleton-loader>
</template>

<style lang="scss" scoped>
@import '@styles';
::v-deep.timesheet-skeleton-list.v-skeleton-loader--is-loading {
  overflow: unset;

  .v-skeleton-loader__week-timesheet-group {
    margin-bottom: 48px;
    overflow: unset;
  }

  .v-skeleton-loader__week-heading .v-skeleton-loader__heading {
    width: 280px;
    margin-bottom: 16px;
  }

  .v-skeleton-loader__timesheet-card {
    margin-bottom: 16px;
    background-color: #fff;
    border-color: #fff;
    border-radius: 24px;
    -webkit-box-shadow: rgb(0 0 0 / 8%) 0 4px 12px;
    box-shadow: rgb(0 0 0 / 8%) 0 4px 12px;
  }

  .v-skeleton-loader__avatar-text {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 16px;

    .v-skeleton-loader__avatar {
      width: 42px;
      height: 42px;
      margin-right: 20px;
    }
    .v-skeleton-loader__text {
      flex: 0 1 auto;
      width: 150px;
      height: 16px;
      margin-left: 12px;
    }
  }

  .v-skeleton-loader__timesheet-table {
    .v-skeleton-loader__heading {
      max-width: 10%;
      height: 16px;
      padding: 0 16px;
    }

    .v-skeleton-loader__table-cell {
      padding: 0 16px;
    }

    .v-skeleton-loader__table-cell:first-child .v-skeleton-loader__text {
      flex: 0 1 auto;
      width: 24px;
      height: 24px;
    }
  }
}
</style>
